// HelpText.js — Прокси-файл для обратной совместимости
// ══════════════════════════════════════════════════════════
// Все тексты подсказок теперь живут в strings.js (секция help).
// Этот файл просто реэкспортирует их, чтобы не ломать
// существующие import { HELP_TEXTS } from './HelpText' в других файлах.
// При мультиязычности тексты будут автоматически на нужном языке.
// ══════════════════════════════════════════════════════════
import { S } from './strings';

// Геттер: каждый раз возвращает тексты на текущем языке
export const HELP_TEXTS = new Proxy({}, {
  get(_, key) { return S().help[key]; }
});
